<template>
  <div>
    <!-- 监控商品设置 -->
    <el-dialog :title="$t('message.monitorProductSettings')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="680px" center>
      <div class="content">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">

          <!-- 监控原因 -->
          <el-form-item :label="$t('message.monitoringReason') + ':'" prop="forbid">
            <div class="type">

              <el-checkbox-group v-model="ruleForm.forbid">
                <el-checkbox :label="item.key" v-for="(item, index) in forbidTypeList" :key="index">{{
                  item.value
                }}</el-checkbox>
              </el-checkbox-group>
            </div>
          </el-form-item>
          <!-- 处理类别 -->
          <el-form-item :label="$t('message.processingClass') + ':'" prop="name">

            <el-checkbox v-model="ruleForm.is_client_hide">客户搜索不显示</el-checkbox>
            <el-checkbox v-model="ruleForm.is_admin_notice">后台提醒</el-checkbox>
          </el-form-item>
          <!-- 商品备注 -->
          <el-form-item :label="$t('message.commodityNote') + ':'" prop="remark">
            <el-input v-model="ruleForm.remark" type="textarea" placeholder="请输入添加商品监控的原因"></el-input>
          </el-form-item>
          <!-- 图片添加 -->
          <el-form-item :label="$t('message.imageAddition') + ':'" prop="name">
            <el-upload :action="baseURL + '/api/common/uploadFile'" list-type="picture-card" :file-list="images"
              :on-preview="handlePictureCardPreview" :on-remove="handleRemove" :before-upload="beforeAvatarUpload"
              :on-success="handleAvatarSuccess" drag>
              <i slot="default" class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
        </el-form>

      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <!-- 新增 -->
        <el-button type="primary" @click="forbidGoodsStore">{{
          $t("message.add")
        }}</el-button>

      </span>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" :visible.sync="imgDialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>
<script>


export default {
  props: {
    checkedList: { type: Array },
  },
  mounted() {
    this.$api.siteConfiguration.forbidTypes().then(res => {
      this.forbidTypeList = res.data
    })
  },
  data() {
    return {
      title: '',
      forbidTypeList: [],
      dialogVisible: false,
      ruleForm: {

      },
      images: [],
      rules: {
        goods_id: [{
          required: true,
          message: this.$t("message.TheRequired"),
          trigger: "blur",
        },],
        platform: [{
          required: true,
          message: this.$t("message.TheRequired"),
          trigger: "blur",
        },],
        forbid: [{
          required: true,
          message: this.$t("message.TheRequired"),
          trigger: "blur",
        },],
        goods_id: [{
          required: true,
          message: this.$t("message.TheRequired"),
          trigger: "blur",
        },],
        remark: [{
          required: true,
          message: this.$t("message.TheRequired"),
          trigger: "blur",
        },],
      },
      dialogImageUrl: '',
      imgDialogVisible: false,
    };
  },
  methods: {
    // 保存
    forbidGoodsStore() {
      let datas = {
        list: [],


      }
      let images = []
      this.images.forEach(item => {
        if (item.response) {
          images.push(item.response.data)
        } else {
          images.push(item.url)
        }
      })
      this.checkedList.forEach(item => {
        datas.list.push({
          goods_id: item.goods_id,
          platform: item.from_platform,
          forbid_type: this.ruleForm.forbid.join(','),
          is_client_hide: this.ruleForm.is_client_hide ? 1 : 0,
          is_admin_notice: this.ruleForm.is_admin_notice ? 1 : 0,
          remark: this.ruleForm.remark,
          pic: item.pic,
          title: item.goods_title,
          images: images
        })
      })
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.$api.siteConfiguration.forbidGoodsStore(datas).then(res => {
            this.$message.success(res.msg)
            this.dialogVisible = false
          })
        }
      })
    },


    // 上传前
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isSVG = file.type === "image/svg+xml";
      if (!isJPG && !isPNG && !isSVG) {
        this.$message.error("上传图片只能是 JPG,PNG 格式,SVG格式!");
      }
      return isJPG || isPNG || isSVG;
    },
    // 删除
    handleRemove(file, fileList) {
      this.images = fileList;
    },
    // 上传
    handleAvatarSuccess(res, file, fileList) {
      this.images = fileList;
    },
    // 查看大图
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.imgDialogVisible = true;
    },
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible) {
        this.images = []
        this.ruleForm = {
          is_client_hide: true,
          is_admin_notice: true,
          forbid: []
        }
      }
    }
  }
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 30px;

  /deep/.el-radio__inner {
    transform: scale(1.5) !important;
  }

  .type {
    /deep/.el-radio {
      margin-bottom: 20px;
    }
  }

  /deep/.el-upload-dragger {
    width: 118px;
    height: 118px;
    border: none;
  }

}
</style>